<template>
  <b-card class="mt-1 p-1" no-body>
    <b-card-img-lazy v-if="imageUrl" :src="imageUrl" alt="poi image is broken" top rounded />
    <SpinnerDiv v-if="loading" />
    <b-card-text class="mt-1 mb-0">
      <div class="d-flex">
        <router-link
          v-if="user.loggedIn"
          :key="poi.bucket"
          :to="{ name: 'poi', params: { id: poi.id } }"
          v-b-tooltip.hover
          title="open details page"
          tag="span"
          style="cursor: pointer;"
        >
          <font-awesome-icon v-if="showDetailsLink" :icon="['fas', 'search']" class="mr-2" />
        </router-link>
        <div v-if="categories.length">
          <template v-for="(category, index) in categories">
            <b-badge variant="secondary" :key="category" :class="{ 'ml-1': index > 0 }">
              <b-link :to="{ name: 'pois-list', query: { categories: category } }" class="text-light">
                <i>#{{ category }}</i>
              </b-link>
            </b-badge>
          </template>
        </div>
        <div v-if="poi.name" class="ml-2">{{ poi.name }}</div>
        <span class="ml-auto"></span>
        <div v-if="hashtags.length">
          <template v-for="(hashtag, index) in hashtags">
            <b-badge variant="secondary" :key="hashtag" :class="{ 'ml-2': index === 0, 'ml-1': index > 0 }">
              <b-link :to="{ name: 'pois-list', query: { hashtags: hashtag } }" class="text-light">
                <i>#{{ hashtag }}</i>
              </b-link>
            </b-badge>
          </template>
        </div>
        <WeatherIcons :weatherConditions="weather" />
        <span v-if="poi.geojson.properties.taken_at" v-b-tooltip.hover :title="toDate | formatDate" class="ml-2">
          <font-awesome-icon :icon="['fas', 'history']" />
        </span>
        <a v-if="poi.geojson.coordinates && isAdmin" :href="getGeoJsonIoUrl" class="ml-2" target="_blank">
          <font-awesome-icon :icon="['fas', 'map-marked-alt']" />
        </a>
      </div>
    </b-card-text>
  </b-card>
</template>

<script>
import { mapGetters } from 'vuex';
import { storage } from '@/main';
import SpinnerDiv from './helpers/SpinnerDiv';
import WeatherIcons from './helpers/WeatherIcons';

export default {
  name: 'PoiCard',
  components: { SpinnerDiv, WeatherIcons },
  data() {
    return {
      errors: [],
      imageUrl: null,
      loading: false,
    };
  },
  props: {
    imageWidth: {
      type: String,
      default: '0600',
      validator: prop => ['0600', '1200', '1900'].includes(prop),
    },
    poi: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      isAdmin: 'auth/isAdmin',
      user: 'auth/user',
    }),
    categories() {
      return this.poi.geojson.properties.categories ? this.poi.geojson.properties.categories : [];
    },
    /**
     * compose url to display the POI on geojson.io
     *
     * @return {string}
     */
    getGeoJsonIoUrl() {
      const poiReduced = JSON.parse(JSON.stringify(this.poi.geojson));
      delete poiReduced.properties;
      return 'http://geojson.io/#data=data:application/json,' + encodeURIComponent(JSON.stringify(poiReduced));
    },
    hashtags() {
      return this.poi.geojson.properties.hashtags ? this.poi.geojson.properties.hashtags : [];
    },
    showDetailsLink() {
      return this.poi.bucket && this.poi.validated && this.$route.name !== 'poi';
    },
    toDate() {
      return new Date(this.poi.geojson.properties.taken_at.seconds * 1000);
    },
    weather() {
      return this.poi.geojson.properties.weather ? this.poi.geojson.properties.weather : [];
    },
  },
  mounted() {
    this.loading = true;
    const storageRef = storage.ref(this.poi.bucket);
    storageRef
      .child(this.imageWidth)
      .getDownloadURL()
      .then(url => {
        this.imageUrl = url;
      })
      .catch(error => {
        this.errors.push(error);
      })
      .finally(() => (this.loading = false));
  },
};
</script>

<style scoped></style>
